import { render, staticRenderFns } from "./TableInstances.vue?vue&type=template&id=3b6d9d75"
import script from "./TableInstances.vue?vue&type=script&lang=js"
export * from "./TableInstances.vue?vue&type=script&lang=js"
import style0 from "./TableInstances.vue?vue&type=style&index=0&id=3b6d9d75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports